// @flow
import * as React from 'react';
import { ButtonBase, Stack, styled, Typography } from '@mui/material';
import { useClient } from '../hooks/client-context';
import { getRoute } from '../../../app/router';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@coverright/ui/inputs';
import { CircleIcon } from '@phosphor-icons/react';

export const SoaStatus = () => {
  const client = useClient();
  const soaDone = client?.recordedLineAgreementCheck && client?.soaAgreementCheck;
  const allDone = soaDone && client?.tpmoAgreementCheck;
  const navigate = useNavigate();

  const color = allDone ? '#03986b' : soaDone ? '#0288d1' : '#a31c1e';

  const label = soaDone ? 'SOA done' : 'SOA not done';

  return (
    <Tooltip title={tooltip}>
      <Button onClick={() => navigate(`/${getRoute('client')}/${client.id}/soa`)}
              sx={{background: `linear-gradient(137deg,rgba(255, 255, 255, 0) 15%, ${color} 19%, rgba(255, 255, 255, 1) 23%, ${color} 24%, rgba(255, 255, 255, 1) 27%, ${color} 30%, ${color} 100%)`,}} >
        <StatusText>{label}</StatusText>
      </Button>
    </Tooltip>
  );
};

const tooltip = <div>
  <Stack direction={'row'} alignItems={'center'} gap={1}>
    <CircleIcon  size={16} color={"#03986b"} weight="fill" />
    All done
  </Stack>
  <Stack direction={'row'} alignItems={'center'} gap={1}>
    <CircleIcon  size={16} color={"#0288d1"} weight="fill" />
    SOA done, TPMO not done
  </Stack>
  <Stack direction={'row'} alignItems={'center'} gap={1}>
    <CircleIcon  size={16} color={"#a31c1e"} weight="fill" />
    SOA not done
  </Stack>
</div>

const Button = styled(ButtonBase)({
  display: 'flex',
  flexShrink: 5,
  flexGrow: 1,
  justifyContent: 'flex-end',
  maxWidth: 160,
  paddingLeft: 50,
})

const StatusText = styled(Typography)({
  color: '#fff',
  textAlign: 'right',
  paddingRight: 8,
  fontSize: 12,
  fontWeight: 500,
  minWidth: 100,
  textTransform: 'uppercase',
  height: 24,
})
